type SuccessHeaderProps = {
  title: string;
};

export default function SuccessHeader({ title }: SuccessHeaderProps) {
  return (
    <div className="flex items-center gap-2 w-full justify-center">
      <img src="/successful.svg" alt="Success" className="w-6 h-6" />
      <h2 className="text-xl font-semibold text-black">{title}</h2>
    </div>
  );
}
